import { restClient } from '@/Core'

import type { UserHistoryItem } from '../Contracts/IUser'

/** Скільки подій тягнемо за раз: з великим запасом на історію однієї людини. */
export const USER_HISTORY_LIMIT = 100

export interface UserHistoryPage {
    items: UserHistoryItem[]
    total: number
}

type HistoryResponse =
    | { items?: UserHistoryItem[]; 'hydra:member'?: UserHistoryItem[]; meta?: { total?: number } }
    | UserHistoryItem[]
    | null

/**
 * Історія змін співробітника: `GET /services/users/{uuid}/history`
 * (`SPEC-005` §3.5, право `USER_READ` — ВП-7). Новіші події — першими.
 *
 * `forceRefresh`: ядровий клієнт дедуплікує GET на 30 с, і без нього
 * вкладка після зміни ролей чи статусу показала б стару стрічку.
 */
export const LoadUserHistoryTask = async (uuid: string): Promise<UserHistoryPage> => {
    const raw = await restClient.get(
        `/services/users/${encodeURIComponent(uuid)}/history?limit=${USER_HISTORY_LIMIT}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as HistoryResponse

    const items = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])
    const total = !Array.isArray(data) && typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items: Array.isArray(items) ? items : [], total }
}
